export const IconBanestes = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M10.13 1.8c2.137 0 3.759.452 4.951 1.403 1.165.928 1.781 2.13 1.781 3.535 0 1.109-.414 2.134-1.168 2.96 1.2.18 2.225.572 3.044 1.156l.179.134.002.001.216.18c1.044.919 1.565 2.056 1.565 3.355 0 1.388-.616 2.588-1.78 3.534l-.001.002c-.562.446-1.237.786-2.13 1.063h-.002L6.62 22.191l-.14.043-.084-.122-4.062-6.02-.034-.05V1.8zm4.379 8.872-.022.01c-.107.056-.238.131-.374.21l-.01.006-.09-.18.09.18-6.78 3.38v6.578l9.098-2.736c.77-.247 1.285-.51 1.733-.86.944-.762 1.383-1.657 1.383-2.736s-.44-1.975-1.385-2.737c-.866-.676-2.058-1.055-3.64-1.119zM3.69 16.095l2.447 3.592v-4.819zm-.206-1.1 2.675-1.35v-4.06h8.014c.994-.7 1.525-1.693 1.525-2.847 0-1.079-.462-1.995-1.384-2.738-.938-.756-2.3-1.14-4.184-1.14H3.485zm3.838-1.92 4.836-2.428H7.323z" />
    </svg>
  );
};
